import {KeypadInfoMainGameState} from '@gongxigames/framework/slot';
import {GameLogic} from 'src/server/GameLogic';

export class GameKeypadInfoMainGameState extends KeypadInfoMainGameState {
    protected onGamePays(): void {
        if (!this.module.isBigWin) {
            const logic = this.module.logic as GameLogic;
            const win = this.module.isFreeGames ? logic.getTotalWin() : logic.getWin();

            if (win > 0) {
                let key;

                if (this.module.isFreeGames) {
                    key = logic.getFreeGames().isBuyBonus() ? 'buyBonusPay' : 'freeGameBonusWin';
                } else {
                    key = 'gamePay';
                }
                const str = this.module.languageService.get(key, {win: this.module.currencyFormatter.formatCents(win)});

                this.view.refreshLeftTicker(str);
            }
        } else {
            if (this.module.isFreeGames) {
                this.module.isBigWinAfterFreeGames = true;
            }
        }
    }

    protected setSpinTickerText(): void {
        this.view.refreshLeftTicker('');
        this.view.refreshRightTicker(this.module.languageService.get('goodLuck'));
    }

    protected onFreeSpinsEnded(): void {
        super.onFreeSpinsEnded();
        const logic = this.module.logic as GameLogic;

        if (logic.getFreeGames().isBuyBonus() && !this.isBigWinFromAllFreeSpins()) {
            const str = this.module.languageService.get('buyBonusPay', {win: this.module.currencyFormatter.formatCents(logic.getTotalWin())});

            this.view.refreshLeftTicker(str);
            this.view.refreshRightTicker(this.module.languageService.get('pressSpin'));
        }
    }
}
